import React from 'react'
import ActionButton from './ActionButton'
import PillBtn from './PillBtn'
import { Link } from 'react-router-dom'
import { useTranslate } from './TranslationText';
import { RemovePlusFromString } from '../helper/RemovePlusFromString';
import { eFormButtonsContainer } from '../common/cssclasses';
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function SupplierCard({ item, baseLink }) {
    const { translate } = useTranslate();
    return (
        <div className='col-lg-6  col-md-12  col-sm-12  mb-main' >
            <div className='bg-white h-100  p-main p-3' style={{ borderRadius: 15 }}>
                <div className='row h-100 rtl'>
                    <Link to={`/SingleSupplier?id=${item?.itemID}&title=${encodeURIComponent(item.itemTitle)}`} className='col-lg-4 col-md-4 col-sm-12 text-center  mb-main supplierImageContainer  '>
                        <img alt='supplier' src={`${MediaBaseURL}${item.itemCover}`} className='m-auto w-100 border-15' />
                    </Link>
                    <div className='col-lg-8 col-md-8 col-sm-12 mb-form-group  ' >
                        <div>
                            <Link to={`/SingleSupplier?id=${item?.itemID}&title=${encodeURIComponent(item.itemTitle)}`} className='horseCardTitle'>
                                {item.itemTitle}
                            </Link>
                            {!!(item.itemPhone) && item.itemPhone != '' &&
                                <Link to={`tel:${item.itemPhone}`} target='_blank' className='Suplliericon'>
                                    <i className=" fa-solid fa-phone C89C66"></i>
                                    <span>{RemovePlusFromString(item.itemPhone)}</span>
                                </Link>}
                            {!!(item.itemEmail) && item.itemEmail != '' &&
                                <Link to={`mailto:${item.itemEmail}`} target='_blank' className='Suplliericon'>
                                    <i className=" fa-regular fa-envelope C89C66"></i>
                                    <span>{item.itemEmail}</span>
                                </Link>}
                            {!!(item.itemWebsite) && item.itemWebsite != '' &&
                                <Link to={`https://${item.itemWebsite}`} target='_blank' className='Suplliericon'>
                                    <i className=" fa-solid fa-globe C89C66"></i>
                                    <span>{item.itemWebsite}</span>
                                </Link>}
                        </div>
                        <div className='horseCardDescription mb-1'>
                            <div className='horseCardTitle mb-form-group'>
                                {translate('web.about', 'About')}
                            </div>
                            {item.itemShortDescription}
                        </div>


                        {/* <ActionButton margin={0} type={'openLink'} text={translate('web.downloadProfile', 'Download Profile')} to={`${MediaBaseURL}${item.itemPdfUrl}`} /> */}
                    </div>
                    <div className={eFormButtonsContainer}>
                        <div className='col-md-6 col-sm-12 col-12 mb-md-0 mb-sm-3 mb-3 pe-md-3 pe-0'>
                            {item.itemPdfUrl !== '' && !!item.itemPdfUrl &&
                                <PillBtn isWithClass classes='w-100' isNoMargin isNoPadding text={translate('web.downloadProfile', 'Download Profile')} isExternal={true} routeName={`${MediaBaseURL}${item.itemPdfUrl}`} />
                            }
                        </div>
                        <div className='col-md-6 col-sm-12 col-12 '>
                            <PillBtn isRed={true} isWithClass classes='w-100' isNoMargin isNoPadding text={translate("web.viewDetails", "View Details")} routeName={`/SingleSupplier?id=${item?.itemID}&title=${encodeURIComponent(item.itemTitle)}`} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
